var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPlaces(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 10.2V16.6667C17.5 17.1269 17.1269 17.5 16.6667 17.5H13.3333C12.8731 17.5 12.5 17.1269 12.5 16.6667V12.0833C12.5 11.8532 12.3135 11.6667 12.0833 11.6667H7.91667C7.68655 11.6667 7.5 11.8532 7.5 12.0833V16.6667C7.5 17.1269 7.1269 17.5 6.66667 17.5H3.33333C2.8731 17.5 2.5 17.1269 2.5 16.6667V10.2C2.50058 9.53718 2.76436 8.90172 3.23333 8.43333L8.925 2.74167C9.08022 2.58771 9.28972 2.50092 9.50833 2.5H10.4917C10.7103 2.50092 10.9198 2.58771 11.075 2.74167L16.7667 8.43333C17.2356 8.90172 17.4994 9.53718 17.5 10.2Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPlaces);
export default __webpack_public_path__ + "static/media/icon-places.6e98cea7.svg";
export { ForwardRef as ReactComponent };